
export default {

  contrastList: state => state.user.contrastList,
  nameConfig: state => state.user.nameConfig
}
